import React, { useEffect } from 'react'
import mockComponentsData from './ThemeScreen/componentData/mockComponentsData'
import { translate } from '../utils/language'

function CheckMissingJson() {

  useEffect(() => {
    let obj = {}
    const components = mockComponentsData
    Object.keys(components).forEach((el, index) => {
      const value = components[el]
      value.variants.forEach((e, i) => {
        const customization = e.customization
        Object.keys(customization).forEach(custom => {
          if (value.options.customization[custom]) {
            const keyToCheck = `${e.type}.${custom}`

            const translatedValue = translate(keyToCheck)
            if (keyToCheck === translatedValue)
              obj[translatedValue] = ""

          }
        })
      })
    })
    console.log(obj)
  }, [])
  return (
    <div>ASIM NABER</div>
  )
}

export default CheckMissingJson